import { Box, Modal, Select } from "@mantine/core";

import { questionTypeOptions } from "./company-question-template-mappers";
import { EDIT_COMPANY_MODAL_TEST_IDS } from "./edit-company-modal.constants";
import type { BasicQuestionEditorState } from "./edit-company-modal.types";
import { BasicQuestionForm } from "@/components/screener-builder/review/basic-question-modal/basic-question-form";
import {
  QuestionType,
  type ReviewPageDraftQuestion,
  type QuestionStateSetter,
} from "@/types/screener-builder";
import type { Nullable } from "@/types/utils";

interface BasicQuestionEditorModalProps {
  editor: Nullable<BasicQuestionEditorState>;
  isMutationPending: boolean;
  onClose: () => void;
  onQuestionTypeSelect: (questionType: QuestionType) => void;
  onSubmit: (question: ReviewPageDraftQuestion) => void;
  setQuestion: QuestionStateSetter;
}

export const BasicQuestionEditorModal = ({
  editor,
  isMutationPending,
  onClose,
  onQuestionTypeSelect,
  onSubmit,
  setQuestion,
}: BasicQuestionEditorModalProps) => (
  <Modal
    centered
    closeOnClickOutside={!isMutationPending}
    closeOnEscape={!isMutationPending}
    onClose={onClose}
    opened={editor != null}
    radius={6}
    size="xl"
    title={
      editor?.selectedQuestion
        ? "Edit default basic question"
        : "Add default basic question"
    }
  >
    {editor?.draftQuestion ? (
      <BasicQuestionForm
        handleClose={onClose}
        isNewQuestion={!editor.selectedQuestion}
        isPublishedScreener={false}
        onSubmit={onSubmit}
        originalQuestion={editor.selectedQuestion}
        question={editor.draftQuestion}
        questionInputTestId={EDIT_COMPANY_MODAL_TEST_IDS.questionEditorInput}
        setQuestion={setQuestion}
        submitButtonTestId={
          EDIT_COMPANY_MODAL_TEST_IDS.questionEditorSaveButton
        }
      />
    ) : (
      <Box mt="md">
        <Select
          clearable={false}
          data={questionTypeOptions()}
          disabled={isMutationPending}
          label="Question type"
          onChange={(value) => {
            if (!value) {
              return;
            }

            onQuestionTypeSelect(value as QuestionType);
          }}
          placeholder="Select..."
        />
      </Box>
    )}
  </Modal>
);
